import React, { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";


const UserList = Loadable(lazy(() => import("../views/approvations/UserList")))

const manageUsersPaths = routeCheck(
    [ 
       { path: "/manage/approvations", element: <UserList/>, auth: authRoles.permitAll},
    ], 
    false 
)

export default manageUsersPaths;